import { alertsAtom } from '@/store';
import { useAtom } from 'jotai';
import BaseAlert from './BaseAlert';

const AlertContainer = () => {
  const [alerts] = useAtom(alertsAtom);
  return (
    <div className="fixed right-32 top-128 z-50">
      <div className="flex flex-col gap-24">
        {Object.keys(alerts).map((key) => {
          return (
            <BaseAlert
              key={key}
              alertId={key}
              message={alerts[key].message}
              subMessage={alerts[key].subMessage}
              type={alerts[key].type}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AlertContainer;
